/* ===== Product Detail Page JS ===== */
(function () {
  'use strict';

  /* ---------- Gallery Hover Zoom ---------- */
  function initHoverZoom() {
    document.querySelectorAll('.pdp__tile').forEach(function (tile) {
      var img = tile.querySelector('.pdp__tile-img');
      if (!img) return;

      tile.addEventListener('mousemove', function (e) {
        var rect = tile.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      tile.addEventListener('mouseleave', function () {
        img.style.transformOrigin = '50% 50%';
      });
    });
  }

  /* ---------- Gallery Navigation Arrows ---------- */
  function initGalleryNav() {
    var gallery = document.querySelector('.pdp__gallery');
    var prevBtn = document.querySelector('.pdp__gallery-arrow--prev');
    var nextBtn = document.querySelector('.pdp__gallery-arrow--next');
    if (!gallery || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = gallery.scrollLeft;
      var maxScroll = gallery.scrollWidth - gallery.clientWidth;
      prevBtn.disabled = scrollLeft <= 2;
      nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    // Reset scroll to start and update arrows
    gallery.scrollLeft = 0;
    updateArrows();
    gallery.addEventListener('scroll', updateArrows, { passive: true });

    prevBtn.addEventListener('click', function() {
      var tiles = gallery.querySelectorAll('.pdp__tile');
      if (!tiles.length) return;
      gallery.scrollBy({ left: -tiles[0].offsetWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      var tiles = gallery.querySelectorAll('.pdp__tile');
      if (!tiles.length) return;
      gallery.scrollBy({ left: tiles[0].offsetWidth, behavior: 'smooth' });
    });
  }

  /* ---------- Color Swatch — Sibling Product Switching ---------- */
  function initSwatches() {
    var section = document.querySelector('[data-pdp-section]');
    if (!section) return;

    var swatches = section.querySelectorAll('.pdp__swatch[data-product-handle]');
    if (!swatches.length) return;

    /* Each colour is its own product, so a swatch opens that product's page.
       Swapping only this section left the rest of the page (Judge.me reviews,
       recommendations, JSON-LD, title) on the previous colour. The page is
       prefetched on hover/touch so the switch still feels instant. */
    var prefetched = {};
    function prefetch(url) {
      if (prefetched[url]) return;
      prefetched[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      document.head.appendChild(link);
    }

    swatches.forEach(function (swatch) {
      var productUrl = '/products/' + swatch.dataset.productHandle;
      if (swatch.classList.contains('is-active')) return;

      ['pointerenter', 'touchstart', 'focus'].forEach(function (evt) {
        swatch.addEventListener(evt, function () { prefetch(productUrl); }, { passive: true });
      });

      swatch.addEventListener('click', function () {
        section.style.opacity = '0.5';
        section.style.pointerEvents = 'none';
        window.location.href = productUrl;
      });
    });
  }

  /* ---------- Available offers: +N more toggle and code copy ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pdp-offers-toggle]');
    if (toggle) {
      var box = toggle.closest('[data-pdp-offers]');
      if (!box) return;
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      box.querySelectorAll('[data-pdp-offer-extra]').forEach(function (el) { el.hidden = !open; });
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = toggle.querySelector('[data-pdp-offers-toggle-label]');
      if (label) label.textContent = toggle.getAttribute(open ? 'data-label-less' : 'data-label-more');
      return;
    }
    var copyBtn = e.target.closest('[data-pdp-offer-copy]');
    if (copyBtn) {
      var code = copyBtn.getAttribute('data-pdp-offer-copy');
      var copyLabel = copyBtn.querySelector('[data-pdp-offer-copy-label]');
      var done = function () {
        if (!copyLabel) return;
        copyLabel.textContent = 'Copied';
        setTimeout(function () { copyLabel.textContent = 'Copy'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    }
  });

  /* ---------- PIN code delivery check (snippets/pdp-delivery-check.liquid) ----------
     Deliverability + shipping cost: a throwaway Storefront API cart for this
     variant and PIN (tokenless access; the shopper's cart is never touched).
     Dates: fulfillment + transit business days (Mon-Fri), same as checkout. */
  function initDeliveryCheck() {
    var box = document.querySelector('[data-pdp-delivery]');
    if (!box) return;
    var form = box.querySelector('[data-pdp-delivery-form]');
    var input = box.querySelector('[data-pdp-delivery-input]');
    var submit = box.querySelector('[data-pdp-delivery-submit]');
    var result = box.querySelector('[data-pdp-delivery-result]');
    var stringsEl = box.querySelector('[data-pdp-delivery-strings]');
    if (!form || !input || !submit || !result || !stringsEl) return;

    var t = {};
    try { t = JSON.parse(stringsEl.innerHTML); } catch (e) { return; }
    /* The t filter HTML-escapes (don&#39;t): decode once so textContent shows plain text. */
    var decoder = document.createElement('textarea');
    Object.keys(t).forEach(function (k) { decoder.innerHTML = t[k]; t[k] = decoder.value; });

    var STORAGE_KEY = 'rr:delivery-pin';
    var variantId = box.getAttribute('data-variant-id');
    var locale = box.getAttribute('data-locale') || 'en';
    var fulfillment = parseInt(box.getAttribute('data-fulfillment-days'), 10) || 0;
    var transitMin = parseInt(box.getAttribute('data-transit-min'), 10) || 0;
    var transitMax = parseInt(box.getAttribute('data-transit-max'), 10) || transitMin;
    var cache = {};
    var controller = null;

    var query = 'mutation($input:CartInput!){cartCreate(input:$input){cart{deliveryGroups(first:5){nodes{deliveryOptions{title estimatedCost{amount currencyCode} deliveryMethodType}}}} userErrors{message}}}';

    function addBusinessDays(date, days) {
      var d = new Date(date.getTime());
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    }

    function formatDate(d) {
      return d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    }

    function formatMoney(amount, currency) {
      try {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(amount);
      } catch (e) {
        return amount + ' ' + currency;
      }
    }

    function show(title, desc, isError) {
      result.innerHTML = '';
      result.classList.toggle('pdp-delivery__result--error', !!isError);
      form.classList.toggle('pdp-delivery__form--error', !!isError);
      input.setAttribute('aria-invalid', isError ? 'true' : 'false');
      if (title) {
        var titleEl = document.createElement('span');
        titleEl.className = 'pdp-delivery__title';
        titleEl.textContent = title;
        result.appendChild(titleEl);
      }
      if (desc) {
        var descEl = document.createElement('span');
        descEl.className = 'pdp-delivery__desc';
        descEl.textContent = desc;
        result.appendChild(descEl);
      }
      result.hidden = false;
    }

    function render(pin, option) {
      if (!option) {
        show('', t.unavailable, true);
        return;
      }
      try { localStorage.setItem(STORAGE_KEY, pin); } catch (e) {}
      var ship = addBusinessDays(new Date(), fulfillment);
      var from = formatDate(addBusinessDays(ship, transitMin));
      var to = formatDate(addBusinessDays(ship, transitMax));
      var range = from === to ? from : from + ' to ' + to;
      var amount = parseFloat(option.estimatedCost && option.estimatedCost.amount);
      var cost = amount > 0
        ? t.shipping.replace('[cost]', formatMoney(amount, option.estimatedCost.currencyCode)).replace('[pin]', pin)
        : t.free.replace('[pin]', pin);
      show(t.deliversBy.replace('[date]', range), cost, false);
    }

    function check(pin) {
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        show('', t.invalid, true);
        return;
      }
      if (cache.hasOwnProperty(pin)) {
        render(pin, cache[pin]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      submit.disabled = true;
      show('', t.checking, false);

      fetch('/api/2025-10/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          query: query,
          variables: { input: {
            lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
            buyerIdentity: { countryCode: 'IN' },
            delivery: { addresses: [{ selected: true, address: { deliveryAddress: { countryCode: 'IN', zip: pin } } }] }
          } }
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
          if (!cart) throw new Error('No cart');
          var option = null;
          cart.deliveryGroups.nodes.forEach(function (group) {
            group.deliveryOptions.forEach(function (o) {
              if (o.deliveryMethodType !== 'SHIPPING') return;
              if (!option || parseFloat(o.estimatedCost.amount) < parseFloat(option.estimatedCost.amount)) option = o;
            });
          });
          cache[pin] = option;
          render(pin, option);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          show('', t.error, true);
        })
        .then(function () { submit.disabled = false; });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      lastChecked = input.value.trim();
      check(lastChecked);
    });

    /* Digits only; editing clears an error; the 6th digit checks straight away. */
    var lastChecked = '';
    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '').slice(0, 6);
      if (digits !== input.value) input.value = digits;
      if (form.classList.contains('pdp-delivery__form--error')) {
        form.classList.remove('pdp-delivery__form--error');
        input.setAttribute('aria-invalid', 'false');
        result.hidden = true;
      }
      if (digits.length === 6 && digits !== lastChecked) {
        lastChecked = digits;
        check(digits);
      }
    });

    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (saved && /^[1-9][0-9]{5}$/.test(saved)) {
      input.value = saved;
      lastChecked = saved;
      check(saved);
    }
  }

  /* ---------- Initialize ---------- */
  initHoverZoom();
  initGalleryNav();
  initSwatches();
  initDeliveryCheck();

  /* Back/forward cache restores the page as it was left: undo the swatch
     loading state so the section isn't stuck dimmed. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var section = document.querySelector('[data-pdp-section]');
    if (section) {
      section.style.opacity = '';
      section.style.pointerEvents = '';
    }
  });
})();
